import { OS_MAINTENANCESEARCH_SHOW_OFF } from '../types'

const state = {
  isOrderMaintenanceModalVisible: false
}

const mutations = {
  [OS_MAINTENANCESEARCH_SHOW_OFF] (state, value) {
    state.isOrderMaintenanceModalVisible = value
  }
}

const getters = {
  isOrderMaintenanceModalVisible: state => {
    return state.isOrderMaintenanceModalVisible
  }
}

const actions = {
  setOrderMaintenanceModalVisible: function ({ commit }, value) {
    commit(OS_MAINTENANCESEARCH_SHOW_OFF, value)
  }
}

export default { state, mutations, actions, getters }
export { mutations, actions, getters }
